import React from 'react'
import styled from 'styled-components'
import { useIntlLocale } from '../hooks'
import PermissionIcon from '../images/no-permission.svg'

const Wrapper = styled.div`
  margin: 0 auto;
  padding-top: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > h3 {
    font-size: 24px;
    margin-bottom: 28px;
    line-height: 1;
  }
  > p {
    margin: 0 0 43px 0;
    font-size: 14px;
    color: rgb(102, 102, 102);
    line-height: 1;
    > b {
      color: #f2063f;
    }
  }
  > img {
    width: 283px;
    height: 247px;
  }
`

export const Button = styled.button`
  color: #fff;
  background: #f2063f;
  border: 0px;
  outline: 0;
  height: 32px;
  transition: 0.5s all;
  cursor: pointer;
  margin-bottom: 70px;
  padding: 0 20px;
  font-size: 12px;
  :hover {
    background: rgb(213, 3, 52);
  }
`

export function NoPermission() {
  const t = useIntlLocale()

  return (
    <Wrapper>
      <h3>{t('permission.1')}</h3>
      <p>
        {t('permission.2')} <b>400-1828-669</b> {t('permission.3')}
      </p>
      <Button onClick={() => (window.location.href = '/share/request-trial')}>
        {t('permission.4')}
      </Button>
      <img src={PermissionIcon} alt='permission' />
    </Wrapper>
  )
}
